import React from 'react';
import { getOrderedChildren } from '../../utils/collectionFolders';
import { FolderRow } from './FolderRow';
import { RequestRow } from './RequestRow';

// ─── CollectionTreeList ───────────────────────────────────────────────────────

export const CollectionTreeList = React.memo(function CollectionTreeList({
  onRequestDelete,
  collection,
  markedIds,
  onRowClick,
  parentId,
  depth,
  expandedFolders,
  onToggleFolder,
  onCreateRequest,
  onContextMenu,
  disableDnd,
  activeDragId,
  selectedRequest,
  selectedFolder,
  onSelectRequest,
  onSelectFolder,
  editingItem,
  onSaveRename,
  onRenameDraft,
  onCancelRename,
  dropIndicator,
  getHandleProps,
  fadeInIds,
}) {
  const children = getOrderedChildren(collection, parentId);

  return (
    <>
      {children.map((entry) => {
        if (entry.type === 'folder') {
          return (
            <FolderRow
              key={entry.id}
              folder={entry.item}
              collection={collection}
              isMarked={!!markedIds?.has(`folder-${entry.id}`)}
              onRowClick={onRowClick}
              expandedFolders={expandedFolders}
              onToggleFolder={onToggleFolder}
              onSelectFolder={onSelectFolder}
              onContextMenu={onContextMenu}
              disableDnd={disableDnd}
              activeDragId={activeDragId}
              selectedFolder={selectedFolder}
              editingItem={editingItem}
              onSaveRename={onSaveRename}
              onRenameDraft={onRenameDraft}
              onCancelRename={onCancelRename}
              dropIndicator={dropIndicator}
              getHandleProps={getHandleProps}
              fadeInIds={fadeInIds}
            >
              <CollectionTreeList
                onRequestDelete={onRequestDelete}
                collection={collection}
                markedIds={markedIds}
                onRowClick={onRowClick}
                parentId={entry.id}
                depth={depth + 1}
                expandedFolders={expandedFolders}
                onToggleFolder={onToggleFolder}
                onCreateRequest={onCreateRequest}
                onContextMenu={onContextMenu}
                disableDnd={disableDnd}
                activeDragId={activeDragId}
                selectedRequest={selectedRequest}
                selectedFolder={selectedFolder}
                onSelectRequest={onSelectRequest}
                onSelectFolder={onSelectFolder}
                editingItem={editingItem}
                onSaveRename={onSaveRename}
                onRenameDraft={onRenameDraft}
                onCancelRename={onCancelRename}
                dropIndicator={dropIndicator}
                getHandleProps={getHandleProps}
                fadeInIds={fadeInIds}
              />
            </FolderRow>
          );
        }
        return (
          <RequestRow
            onRequestDelete={onRequestDelete}
            key={entry.id}
            request={entry.item}
            isMarked={!!markedIds?.has(`request-${entry.id}`)}
            onRowClick={onRowClick}
            activeDragId={activeDragId}
            selectedRequest={selectedRequest}
            onSelectRequest={onSelectRequest}
            onContextMenu={onContextMenu}
            disableDnd={disableDnd}
            editingItem={editingItem}
            onSaveRename={onSaveRename}
            onRenameDraft={onRenameDraft}
            onCancelRename={onCancelRename}
            indent={depth + 1}
            dropIndicator={dropIndicator}
            getHandleProps={getHandleProps}
            fadeInIds={fadeInIds}
          />
        );
      })}
    </>
  );
});
